var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSupport = function SvgSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 110 110"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55 110c30.376 0 55-24.624 55-55S85.376 0 55 0 0 24.624 0 55s24.624 55 55 55z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#102258",
    d: "M28.328 89H5.672C3.102 89 1 86.696 1 83.88V41.12C1 38.305 3.102 36 5.672 36h22.656C30.898 36 33 38.304 33 41.12v42.503C33 86.696 30.898 89 28.328 89zm38.001 0H43.672C41.102 89 39 86.759 39 84.02V31.98c0-2.74 2.102-4.98 4.672-4.98h22.657C68.898 27 71 29.241 71 31.98v52.04c0 2.74-2.102 4.98-4.671 4.98z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0CBE7",
    d: "M104.328 89H81.671C79.102 89 77 86.97 77 84.49V31.51c0-2.48 2.102-4.51 4.671-4.51h22.657c2.57 0 4.672 2.03 4.672 4.51v52.98c0 2.48-2.102 4.51-4.672 4.51z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#5069DC",
    d: "M104.328 89H81.671C79.102 89 77 86.904 77 84.343V55h32v29.343c0 2.561-2.102 4.657-4.672 4.657z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EB273",
    d: "M52.996 18.845C52.996 30.528 45.426 40 33.952 40s-22.507-9.402-20.776-22.918C14.908 3.566 27.023.709 35.106.04c8.083-.669 17.89 7.12 17.89 18.805z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "m31.158 21.414-3.832-3.443a2.015 2.015 0 0 0-2.782.055 1.86 1.86 0 0 0 .057 2.691L31.77 27l9.904-12.056s.872-1.435-.253-2.314c-1.126-.879-2.518-.911-3.587.368l-6.676 8.416z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EB273",
    d: "M53.58 43.954c-.004 1.163-.91 1.604-2.105 1.392-1.194-.212-1.179-1.016-1.214-1.628-.061-1.044 1.028-1.58 1.761-1.453.733.127 1.564.527 1.559 1.69z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#10412D",
    d: "M62.965 10.776c.235 1.462-.73 2.22-2.167 2.22-1.436 0-1.585-1.015-1.754-1.776-.287-1.3.873-2.216 1.754-2.22.881-.004 1.932.313 2.167 1.776zM10.138 11.98c-.484.78-.518 1.5-1.938 1.5s-1.938-1.056-1.938-1.5c0-1.331.518-2.5 1.938-2.5s2.423 1.72 1.938 2.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EB273",
    d: "M72.961 1.974C73.187 3.286 72.145 4 70.727 4c-1.418 0-1.73-1.33-1.73-1.774 0-1.33.47-2.332 1.73-2.217 1.26.115 2.009.654 2.234 1.965zM7.88 28.104c.508 1.423-.725 2.22-2.147 2.22-1.423 0-1.737-1.332-1.737-1.776 0-1.332.315-2.22 1.737-2.22 1.423 0 1.637.352 2.146 1.776z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#1EB273",
    fillRule: "evenodd",
    d: "M91.775 20.276 89.22 17.98a1.343 1.343 0 0 0-1.855.037 1.24 1.24 0 0 0 .038 1.793l4.78 4.19 6.602-8.038s.582-.956-.169-1.542c-.75-.586-1.678-.607-2.39.245l-4.451 5.61z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#B9C3CA",
    fillRule: "evenodd",
    d: "m73.577 19.02-1.916-1.835a.962.962 0 0 0-1.39.03 1.038 1.038 0 0 0 .028 1.434L73.883 22l4.952-6.43s.436-.765-.127-1.234c-.562-.469-1.259-.486-1.793.196l-3.338 4.489z",
    clipRule: "evenodd"
  })));
};
export default SvgSupport;